/* AMANA — Drawer "rip Qikify" : pilote la structure qsc2-* (HTML/CSS copiés du live).
   Comportement réécrit (Qikify ne fournit pas son JS). Refresh via Section Rendering API. */
(function () {
  'use strict';
  var SECTION = 'qikify-cart';
  function q(sel, root) { return (root || document).querySelector(sel); }
  function drawerEl() { return q('[data-qsc-drawer]'); }
  function overlayEl() { return q('[data-qsc-overlay]'); }
  // Préfixe locale ('/' ou '/de/...') lu sur le drawer : rend les fetches cart/sections localisés
  // (sinon le re-render du drawer et les messages d'erreur Shopify reviennent en FR sur /en /es /de).
  function rootUrl() {
    var d = drawerEl();
    var r = (d && d.getAttribute('data-qsc-root')) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  // Libellés traduits injectés par la section (blob JSON data-qsc-i18n, clés amana.cart.* des locale files).
  var I18N;
  function i18n(key, fallback) {
    if (!I18N) {
      var el = q('[data-qsc-i18n]');
      try { I18N = el ? JSON.parse(el.textContent) : {}; } catch (e) { I18N = {}; }
    }
    return I18N[key] || fallback;
  }
  var discountCode = '';
  var copyTimer = null;
  var GIFT_VIDS = [49410836627796, 55675544142164]; // dustbag + magazine : exclus du lien partagé
  var wishlisted = new Set(); // handles favorisés cette session (cœur plein conservé au refresh du drawer)
  var wishedPids = new Set(); // productIds DÉJÀ en wishlist (lus depuis l'app au chargement → cœurs pleins dès le premier rendu)

  // ---------------------------------------------------------------------------
  // Couche analytics du drawer — UN SEUL point d'émission (track) → destinations pluggables.
  // Stratégie "structure d'abord, câblage ensuite" : GA4 ACTIF ; Meta et Clarity PRÉPARÉS mais OFF.
  // Events émis = ceux que Shopify NE capte PAS (view_cart, select_item, remove_from_cart, share,
  // add_to_wishlist). add_to_cart / view_item / purchase sont déjà émis par le Web Pixel Shopify
  // (vers GA4 ET Meta) → on ne les double JAMAIS ici.
  //
  // POUR CÂBLER META plus tard (une fois CAPI + déduplication event_id validées en interface) :
  //   1) ANALYTICS.meta.enabled = true
  //   2) compléter META_EVENT_MAP (n'émettre QUE les events NON captés par le Web Pixel, sinon double-fire)
  //   3) si la CAPI est active : passer le MÊME event_id côté navigateur et serveur (dédup)
  // POUR CÂBLER CLARITY : ANALYTICS.clarity.enabled = true + ajouter le loader dans theme.liquid.
  // Détails : wiki shopify/cart-drawer § Analytics.
  var ANALYTICS = {
    ga4:     { enabled: true,  id: 'G-45ZR144L2K' },
    meta:    { enabled: false, pixelId: '1469991467035506' }, // le Web Pixel Shopify gère déjà le pixel — câblage différé
    clarity: { enabled: false, projectId: '' }
  };
  var lastViewCart = 0;
  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') return cp.analyticsProcessingAllowed();
    } catch (e) {}
    return true; // défaut : laisser le Consent Mode de gtag arbitrer le consentement
  }
  // GA4 (gtag) — ACTIF.
  function sendGA4(name, params) {
    if (!ANALYTICS.ga4.enabled || typeof window.gtag !== 'function') return;
    try { window.gtag('event', name, Object.assign({ send_to: ANALYTICS.ga4.id }, params || {})); } catch (e) {}
  }
  // Meta (fbq) — OFF. Mapping event interne -> event Meta standard (null = ne pas envoyer : déjà
  // couvert par le Web Pixel, ou pas d'équivalent standard). add_to_wishlist = candidat n°1 au câblage.
  var META_EVENT_MAP = {
    view_cart: null, select_item: null, remove_from_cart: null, share: null, add_to_wishlist: 'AddToWishlist'
  };
  function sendMeta(name, params) {
    if (!ANALYTICS.meta.enabled || typeof window.fbq !== 'function') return;
    var ev = META_EVENT_MAP[name];
    if (!ev) return;
    var p = (params && params.value != null) ? { value: params.value, currency: params.currency || 'EUR' } : {};
    try { window.fbq('track', ev, p); } catch (e) {}
  }
  // Microsoft Clarity — OFF. Le session-replay se charge via un snippet (theme.liquid) ;
  // ici on ne fait que tagger les events en "custom tags" quand il sera activé.
  function sendClarity(name) {
    if (!ANALYTICS.clarity.enabled || typeof window.clarity !== 'function') return;
    try { window.clarity('event', name); } catch (e) {}
  }
  // Point d'émission unique appelé partout dans le drawer.
  function track(name, params) {
    if (!canTrack()) return;
    sendGA4(name, params);
    sendMeta(name, params);   // no-op tant que ANALYTICS.meta.enabled = false
    sendClarity(name);        // no-op tant que ANALYTICS.clarity.enabled = false
  }
  function priceFromText(t) { // "€1 234,50" -> 1234.5 ; "Offert" -> 0
    if (!t) return 0;
    var s = String(t).replace(/\s/g, '').replace(/[^\d.,]/g, '');
    if (!s) return 0;
    s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isNaN(n) ? 0 : n;
  }
  function itemFromRow(row) { // item GA4 depuis une ligne panier (DOM du drawer)
    if (!row) return null;
    var titleEl = row.querySelector('.qsc2-product-item__product-title span');
    var priceEl = row.querySelector('.qsc2-product-item__line-price');
    var qtyInp = row.querySelector('[data-qsc-qty-input]');
    var qty = qtyInp ? (parseInt(qtyInp.value, 10) || 1) : 1;
    var line = priceFromText(priceEl && priceEl.textContent);
    return {
      item_id: row.getAttribute('data-qsc-variant') || '',
      item_name: titleEl ? titleEl.textContent.trim() : '',
      price: qty > 0 ? Math.round((line / qty) * 100) / 100 : line,
      quantity: qty
    };
  }
  function trackViewCart() { // ouverture du drawer ; lit /cart.js pour des prix exacts
    var now = Date.now();
    if (now - lastViewCart < 600) return; // openDrawer peut être appelé 2x rapprochés
    lastViewCart = now;
    if (!canTrack() || !ANALYTICS.ga4.enabled) return; // view_cart ne concerne que GA4 (pas de mapping Meta)
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || !c.items || !c.items.length) return;
        var items = c.items.filter(function (it) { return it.final_price > 0; }).map(function (it) {
          return { item_id: String(it.variant_id), item_name: it.product_title, item_variant: it.variant_title || undefined, price: it.final_price / 100, quantity: it.quantity };
        });
        track('view_cart', { currency: c.currency || 'EUR', value: c.total_price / 100, items: items });
      })
      .catch(function () {});
  }

  function openDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d) return;
    d.classList.remove('qsc2-drawer--hidden');
    if (o) o.classList.remove('qsc2-overlay--hidden');
    document.body.style.overflow = 'hidden';
    trackViewCart(); // GA4 : ouverture du panier (non capté par Shopify)
  }
  function closeDrawer() {
    var d = drawerEl(), o = overlayEl();
    if (!d) return;
    d.classList.add('qsc2-drawer--hidden');
    if (o) o.classList.add('qsc2-overlay--hidden');
    document.body.style.overflow = '';
  }

  // Re-render le contenu du drawer depuis le serveur (panier à jour). Source = notre propre
  // section Shopify (HTML de confiance) ; parsing via DOMParser (n'exécute aucun script).
  function refresh(cb) {
    fetch(rootUrl() + '?sections=' + SECTION, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (html == null) { if (cb) cb(); return; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newContent = doc.querySelector('.qsc2-drawer__content');
        var cur = drawerEl();
        if (newContent && cur) {
          var curContent = cur.querySelector('.qsc2-drawer__content');
          if (curContent) curContent.replaceWith(document.adoptNode(newContent));
        }
        applyWishlistState(); // ré-appliquer les cœurs favoris (le content a été remplacé)
        var cnt = doc.querySelector('[data-qsc-count]');
        if (cnt) document.querySelectorAll('[data-header-cart-count],[data-cart-count]').forEach(function (e) { e.textContent = cnt.textContent; });
        if (cb) cb();
      })
      .catch(function () { if (cb) cb(); });
  }

  function changeLine(line, qty, delay) {
    fetch(rootUrl() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) })
      .then(function () { setTimeout(refresh, delay || 0); })
      .catch(function () { setTimeout(refresh, delay || 0); });
  }
  // Toast d'erreur dans le drawer (ex. 422 "déjà tous dans votre panier" sur un article à stock 1 :
  // sans feedback, le client croit que le bouton est cassé).
  function qscToast(msg) {
    var d = drawerEl(); if (!d) return;
    var t = d.querySelector('[data-qsc-toast]');
    if (!t) {
      t = document.createElement('div');
      t.setAttribute('data-qsc-toast', '');
      t.style.cssText = 'position:absolute;left:12px;right:12px;bottom:14px;z-index:60;background:#2b062b;color:#fff;padding:10px 14px;border-radius:8px;font-size:13px;line-height:1.4;box-shadow:0 8px 24px rgba(0,0,0,.25);opacity:0;transition:opacity .2s;pointer-events:none';
      d.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function () { t.style.opacity = '1'; });
    clearTimeout(t.__hide);
    t.__hide = setTimeout(function () { t.style.opacity = '0'; }, 3500);
  }
  function toastFromResponse(r, fallback) {
    return r.json().catch(function () { return {}; }).then(function (j) { qscToast(j.description || j.message || fallback); });
  }

  function addVariant(id) {
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) {
        if (!r.ok) toastFromResponse(r, i18n('toast_unavailable', 'Article indisponible.'));
        refresh(); // même en erreur : re-render restaure le bouton reco (sinon spinner figé)
        // Sur /cart, les recos vivent dans cart-form (page) : rebuild aussi la page, sinon item ajouté invisible + spinner figé
        if (document.getElementById('section-cart') && typeof window.refreshCart === 'function') window.refreshCart();
      })
      .catch(function () { refresh(); });
  }

  // Permalink de partage du panier, construit SYNCHRONEMENT depuis le DOM du drawer
  // (cadeaux exclus ; ils se recalculent chez le destinataire). storefront=true => arrive au panier.
  // Synchrone = pas d'await => compatible navigator.share (qui exige un "user gesture" non rompu).
  function buildCartLinkSync() {
    var parts = [];
    document.querySelectorAll('[data-qsc-line][data-qsc-variant]').forEach(function (row) {
      var vid = parseInt(row.getAttribute('data-qsc-variant'), 10);
      if (!vid || GIFT_VIDS.indexOf(vid) !== -1) return; // exclut les cadeaux offerts
      var inp = row.querySelector('[data-qsc-qty-input]');
      var qty = inp ? (parseInt(inp.value, 10) || 1) : 1;
      parts.push(vid + ':' + qty);
    });
    return parts.length ? (location.origin + rootUrl() + 'cart/' + parts.join(',') + '?storefront=true') : (location.origin + rootUrl() + 'cart');
  }

  // Clic sur "Partager mon panier" : feuille de partage native si dispo (mobile), sinon false (=> panneau d'options).
  function shareCart() {
    var url = buildCartLinkSync();
    if (navigator.share) {
      navigator.share({ title: i18n('share_title', 'Mon panier AMANA'), text: i18n('share_text', 'Découvrez ma sélection AMANA'), url: url })
        .then(function () { track('share', { method: 'native', content_type: 'cart' }); })
        .catch(function () {});
      return true;
    }
    return false;
  }

  // Option de partage explicite (panneau desktop).
  function shareVia(type, labelEl) {
    var url = buildCartLinkSync();
    var msg = i18n('share_text', 'Découvrez ma sélection AMANA') + ' : ' + url;
    track('share', { method: type, content_type: 'cart' }); // GA4 : partage panier + canal
    if (type === 'whatsapp') window.open('https://wa.me/?text=' + encodeURIComponent(msg), '_blank', 'noopener');
    else if (type === 'email') window.location.href = 'mailto:?subject=' + encodeURIComponent(i18n('share_title', 'Mon panier AMANA')) + '&body=' + encodeURIComponent(msg);
    else if (type === 'copy') copyText(url, labelEl);
  }

  // Copie robuste : clipboard async + fallback execCommand si la promesse reste pending
  // (Piège HTTPS/strict : .then jamais appelé) ; clearTimeout anti-accumulation du feedback.
  function copyText(text, labelEl) {
    var ORIGINAL = labelEl ? (labelEl.getAttribute('data-orig') || labelEl.textContent) : i18n('copy_link', 'Copier le lien');
    if (labelEl && !labelEl.getAttribute('data-orig')) labelEl.setAttribute('data-orig', ORIGINAL);
    var done = false;
    function flash() {
      if (copyTimer) clearTimeout(copyTimer);
      labelEl.textContent = i18n('link_copied', 'Lien copié !');
      copyTimer = setTimeout(function () { labelEl.textContent = ORIGINAL; }, 2000);
    }
    function ok() { if (done) return; done = true; flash(); }
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = text; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        document.execCommand('copy'); document.body.removeChild(ta);
      } catch (e) {}
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(ok, function () { fallback(); ok(); });
      setTimeout(function () { if (!done) { fallback(); ok(); } }, 600);
    } else {
      fallback(); ok();
    }
  }

  // Favori : pilote l'app wishlist (Swish / Wishlist King) via window.WishlistKing.
  // Le SDK est chargé sur toutes les pages ; addWishlistItem({...,inWishlist}) ajoute (false) ou retire (true).
  function wkReady() { return window.WishlistKing && typeof window.WishlistKing.addWishlistItem === 'function'; }

  function setHeartFilled(btn, filled) {
    var svg = btn.querySelector('svg');
    if (svg) svg.style.fill = filled ? 'currentColor' : 'none';
    btn.setAttribute('aria-pressed', filled ? 'true' : 'false');
  }

  // État initial des cœurs : lit la wishlist existante via l'API Appmate (backend de Wishlist King).
  // Endpoint découvert via la page /pages/ma-wishlist : GET https://api.appmate.io/v2/wishlists/mine
  // avec les headers (session + shop) exposés par le SDK (wk._apis.wishlist.headers). Lève la limite
  // documentée « après reload, le cœur repart vide ». Retry : le SDK charge en async.
  function loadWishlistState(attempt) {
    attempt = attempt || 0;
    var wk = window.WishlistKing;
    var headers = wk && wk._apis && wk._apis.wishlist && wk._apis.wishlist.headers;
    if (!headers) { if (attempt < 20) setTimeout(function () { loadWishlistState(attempt + 1); }, 500); return; }
    fetch('https://api.appmate.io/v2/wishlists/mine', { headers: headers })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var items = j && j.wishlist && j.wishlist.items;
        if (!items || !items.length) return;
        items.forEach(function (it) { if (it.productId) wishedPids.add(it.productId); });
        applyWishlistState();
      })
      .catch(function () {});
  }

  function isWished(btn) {
    if (wishlisted.has(btn.getAttribute('data-wl-handle'))) return true;
    return wishedPids.has(parseInt(btn.getAttribute('data-wl-product'), 10) || 0);
  }

  // Ré-applique l'état (cœur plein) après un re-render du drawer (session + wishlist persistée).
  function applyWishlistState() {
    document.querySelectorAll('[data-qsc-wishlist]').forEach(function (btn) {
      setHeartFilled(btn, isWished(btn));
    });
  }

  function toggleWishlist(btn) {
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle || !wkReady()) return;
    var productId = parseInt(btn.getAttribute('data-wl-product'), 10) || 0;
    var variantId = parseInt(btn.getAttribute('data-wl-variant'), 10) || 0;
    var wasIn = isWished(btn);
    // UI optimiste (maintenir les DEUX sets : handle session + productId persistant)
    setHeartFilled(btn, !wasIn);
    if (wasIn) { wishlisted.delete(handle); wishedPids.delete(productId); }
    else { wishlisted.add(handle); wishedPids.add(productId); }
    if (!wasIn) { // GA4 : ajout favori (l'app gère le stockage ; on mesure l'intention)
      var wItem = itemFromRow(btn.closest('[data-qsc-line]'));
      track('add_to_wishlist', wItem ? { currency: 'EUR', value: wItem.price, items: [wItem] } : { items: [{ item_id: String(variantId), item_name: handle }] });
    }
    var rollback = function () {
      setHeartFilled(btn, wasIn);
      if (wasIn) { wishlisted.add(handle); wishedPids.add(productId); }
      else { wishlisted.delete(handle); wishedPids.delete(productId); }
    };
    if (wasIn) {
      // RETRAIT : addWishlistItem({inWishlist:true}) ne retire PAS (il AJOUTE un doublon — bug découvert 2026-06-11).
      // Vraie API : removeItem({wishlistId:'mine', wishlistItemId}) — itemId à résoudre via GET mine.
      // On supprime TOUS les items du productId (purge aussi les doublons historiques).
      var wlApi = window.WishlistKing._apis && window.WishlistKing._apis.wishlist;
      if (!wlApi) { rollback(); return; }
      fetch('https://api.appmate.io/v2/wishlists/mine', { headers: wlApi.headers, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var hits = (j.wishlist && j.wishlist.items || []).filter(function (i) { return i.productId === productId; });
          return Promise.all(hits.map(function (i) { return wlApi.removeItem({ wishlistId: 'mine', wishlistItemId: i.id }); }));
        })
        .catch(rollback);
    } else {
      // AJOUT : inWishlist = état avant le clic (false => l'app ajoute)
      Promise.resolve(window.WishlistKing.addWishlistItem({ productHandle: handle, productId: productId, variantId: variantId, inWishlist: false }))
        .catch(rollback);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    if (t.closest('[data-qsc-close]') || t.closest('[data-qsc-overlay]')) { e.preventDefault(); closeDrawer(); return; }

    var rm = t.closest('[data-qsc-remove]');
    if (rm) {
      e.preventDefault();
      var w = rm.closest('[data-qsc-line]');
      if (w) {
        var remItem = itemFromRow(w); // GA4 : retrait (capturé avant le slide-out)
        if (remItem) track('remove_from_cart', { currency: 'EUR', value: (remItem.price * remItem.quantity) || 0, items: [remItem] });
        w.style.transition = 'opacity .25s ease, transform .25s ease';
        w.style.opacity = '0';
        w.style.transform = 'translateX(24px)';
        changeLine(parseInt(w.getAttribute('data-qsc-line'), 10), 0, 260);
      }
      return;
    }

    var qb = t.closest('[data-qsc-qty]');
    if (qb) {
      e.preventDefault();
      var w2 = qb.closest('[data-qsc-line]');
      if (w2) {
        var delta = parseInt(qb.getAttribute('data-qsc-qty'), 10);
        var inp = w2.querySelector('[data-qsc-qty-input]');
        var cur = inp ? parseInt(inp.value, 10) : 1;
        changeLine(parseInt(w2.getAttribute('data-qsc-line'), 10), Math.max(0, cur + delta));
      }
      return;
    }

    var ra = t.closest('[data-qsc-rec-add]');
    if (ra) {
      e.preventDefault();
      if (ra.getAttribute('aria-busy') === 'true') return; // anti double-clic
      ra.setAttribute('aria-busy', 'true');
      ra.disabled = true;
      // GA4 : clic sur une reco (l'add_to_cart sera émis par Shopify ; ici on mesure l'engagement avec la liste)
      var rcard = ra.closest('.qsc2-r-product');
      if (rcard) {
        var rT = rcard.querySelector('.qsc2-r-product__product-title span');
        var rP = rcard.querySelector('.qsc2-r-product__price');
        track('select_item', { item_list_id: 'drawer_recommendations', item_list_name: 'Pour sublimer votre sac', items: [{ item_id: ra.getAttribute('data-qsc-rec-add') || '', item_name: rT ? rT.textContent.trim() : '', price: priceFromText(rP && rP.textContent), quantity: 1 }] });
      }
      // Comme Qikify : remplacer le label par un spinner pendant l'ajout (refresh restaure le bouton)
      while (ra.firstChild) ra.removeChild(ra.firstChild);
      var sp = document.createElement('span'); sp.className = 'qsc2-spinner'; ra.appendChild(sp);
      addVariant(ra.getAttribute('data-qsc-rec-add'));
      return;
    }

    if (t.closest('[data-qsc-promo-open]')) {
      e.preventDefault();
      var p = q('[data-qsc-promo-panel]'); if (p) p.classList.remove('qsc2-sf-content--hide');
      var pi = q('[data-qsc-promo-input]');
      try { if (pi && !pi.value) pi.value = localStorage.getItem('stickycart-discount-code') || ''; } catch (err) {}
      return;
    }
    if (t.closest('[data-qsc-promo-close]')) { e.preventDefault(); var p2 = q('[data-qsc-promo-panel]'); if (p2) p2.classList.add('qsc2-sf-content--hide'); return; }
    if (t.closest('[data-qsc-promo-save]')) {
      e.preventDefault();
      var inp3 = q('[data-qsc-promo-input]');
      var code = inp3 ? inp3.value.trim() : '';
      discountCode = code;
      try { localStorage.setItem('stickycart-discount-code', code); } catch (err) {}
      // Comme Qikify : applique la remise au panier via /cart/update.js (Shopify la calcule).
      var fd = new FormData(); fd.append('discount', code);
      fetch(rootUrl() + 'cart/update.js', { method: 'POST', body: fd })
        .then(function () { var p3 = q('[data-qsc-promo-panel]'); if (p3) p3.classList.add('qsc2-sf-content--hide'); refresh(); })
        .catch(function () { refresh(); });
      return;
    }

    if (t.closest('[data-qsc-checkout]')) {
      e.preventDefault();
      window.location.href = '/checkout'; // la remise est déjà appliquée au panier (cart/update.js)
      return;
    }

    // --- Tooltip "rappel valeur" (réassurance) : toggle au clic ; ferme au clic extérieur. Pas d'ID (le drawer est global) → pas de conflit avec le bloc identique de la page produit. ---
    var spTip = t.closest('[data-sp-tip-toggle]');
    if (spTip) {
      e.preventDefault();
      var spW = spTip.closest('.sp-tooltip-wrapper');
      var spWillOpen = spW && !spW.classList.contains('active');
      document.querySelectorAll('.sp-tooltip-wrapper.active').forEach(function (x) { x.classList.remove('active'); });
      if (spWillOpen) spW.classList.add('active');
      return;
    }
    if (!t.closest('.sp-tooltip-content')) {
      document.querySelectorAll('.sp-tooltip-wrapper.active').forEach(function (x) { x.classList.remove('active'); });
    }

    var heart = t.closest('[data-qsc-wishlist]');
    if (heart) {
      e.preventDefault();
      toggleWishlist(heart);
      return;
    }

    if (t.closest('[data-qsc-share-open]')) {
      e.preventDefault();
      if (!shareCart()) { // pas de partage natif (desktop) → ouvrir le panneau d'options
        var sp = q('[data-qsc-share-panel]');
        if (sp) sp.classList.remove('qsc2-sf-content--hide');
      }
      return;
    }
    if (t.closest('[data-qsc-share-close]')) {
      e.preventDefault();
      var sp2 = q('[data-qsc-share-panel]');
      if (sp2) sp2.classList.add('qsc2-sf-content--hide');
      return;
    }
    var shareOpt = t.closest('[data-qsc-share]');
    if (shareOpt) {
      e.preventDefault();
      shareVia(shareOpt.getAttribute('data-qsc-share'), shareOpt.querySelector('[data-qsc-copy-label]'));
      return;
    }

    var cartLink = t.closest('a[href$="/cart"], a[href*="/cart?"], [data-qsc-open]');
    if (cartLink && !t.closest('[data-qsc-drawer]')) { e.preventDefault(); openDrawer(); refresh(); return; }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' || e.keyCode === 27) closeDrawer(); });

  // --- Upsell dustbag d'origine : cocher = ajoute la quantité manquante, décocher = retire tout
  // (update.js {vid:0} — change.js refuse id=variant_id, cf wiki). L'état de la checkbox est
  // recalculé en Liquid à chaque refresh() de section : pas d'état JS à maintenir.
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-qsc-dustbag-input]')) return;
    var row = input.closest('[data-qsc-dustbag]');
    if (!row || row.classList.contains('is-busy')) return;
    var vid = row.getAttribute('data-db-variant');
    var qty = parseInt(row.getAttribute('data-db-qty'), 10) || 1;
    var checked = input.checked;
    row.classList.add('is-busy');
    var req;
    if (checked) {
      req = fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) });
    } else {
      var updates = {}; updates[vid] = 0;
      req = fetch(rootUrl() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) });
    }
    req.then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        if (!checked) { // GA4 : retrait (l'add_to_cart du cocher est émis par Shopify). Quantité retirée = ce qui était au panier (update vid:0 retire tout), pas la qty manquante.
          var dbPrice = parseFloat(row.getAttribute('data-db-price')) || 0;
          var dbIn = parseInt(row.getAttribute('data-db-in'), 10) || 1;
          track('remove_from_cart', { currency: 'EUR', value: dbPrice * dbIn, items: [{ item_id: String(vid), item_name: row.getAttribute('data-db-title') || "Le Dustbag d'origine", price: dbPrice, quantity: dbIn }] });
        }
        refresh(); // re-render → checkbox recalculée, ligne dustbag affichée/retirée
      })
      .catch(function () { input.checked = !checked; row.classList.remove('is-busy'); });
  });

  // Ajout au panier : on prend le contrôle (clic ET submit, en capture) pour ouvrir le drawer
  // + mettre un spinner sur le bouton. Garde __qscBusy pour ne pas traiter deux fois.
  function qscHandleAdd(form, btn, evt) {
    if (evt) { evt.preventDefault(); evt.stopPropagation(); }
    if (form.__qscBusy) return;
    // Anti-doublon sac (pièce unique) : si le variant est déjà une ligne du drawer avec un prix
    // unitaire >= 50 € (heuristique sac d'auto-gift : entretien < 50 €, cadeaux 0 €), on n'envoie
    // PAS le add.js — feedback immédiat au lieu du 422 Shopify, et couvre sa fenêtre de course
    // en rafale (qty 2 acceptée sur stock 1, cf wiki). Les lignes du drawer sont re-rendues à
    // chaque mutation : vérification synchrone toujours fraîche.
    var dupInp = form.querySelector('[name="id"]');
    var dupVid = dupInp && parseInt(dupInp.value, 10);
    if (dupVid) {
      var dupRow = q('[data-qsc-line][data-qsc-variant="' + dupVid + '"]');
      var dupItem = dupRow && itemFromRow(dupRow);
      if (dupItem && dupItem.price >= 50) {
        openDrawer();
        qscToast(i18n('toast_already', 'Cet article est déjà dans votre panier.'));
        return;
      }
    }
    form.__qscBusy = true;
    openDrawer(); // slide-in immédiat (comme Qikify)
    var restore = function () { form.__qscBusy = false; };
    if (btn && btn.getAttribute('data-qsc-adding') !== '1') {
      btn.setAttribute('data-qsc-adding', '1');
      var prevPos = btn.style.position, prevColor = btn.style.color, wasDisabled = btn.disabled;
      var textColor = getComputedStyle(btn).color; // couleur d'origine pour le spinner
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.color = 'transparent';
      btn.disabled = true;
      var sp = document.createElement('span');
      sp.className = 'qsc2-spinner';
      sp.style.cssText = 'position:absolute;top:50%;left:50%;margin:0;transform:translate(-50%,-50%);border-color:transparent ' + textColor + ' ' + textColor;
      btn.appendChild(sp);
      var prev = restore;
      restore = function () {
        if (sp.parentNode) sp.parentNode.removeChild(sp);
        btn.style.color = prevColor; btn.style.position = prevPos; btn.disabled = wasDisabled;
        btn.removeAttribute('data-qsc-adding');
        prev();
      };
    }
    var fd = new FormData(form);
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', body: fd })
      .then(function (r) {
        if (!r.ok) toastFromResponse(r, i18n('toast_add_failed', "Impossible d'ajouter cet article.")); // ex. 422 stock épuisé / déjà au panier
        refresh();
        setTimeout(restore, 350);
      })
      .catch(function () { restore(); });
  }

  // Clic sur le bouton ajouter (capture) — avant le JS du thème (sinon il navigue/ajax)
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('button[name="add"], button[type="submit"], [data-add-to-cart]');
    if (!btn) return;
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;
    qscHandleAdd(form, btn, e);
  }, true);

  // Submit (capture) — fallback (touche Entrée, formulaires sans bouton type=submit)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.action && form.action.indexOf('/cart/add') > -1) {
      qscHandleAdd(form, form.querySelector('button[name="add"], button[type="submit"], [data-add-to-cart]'), e);
    }
  }, true);

  window.QscCart = { open: function () { refresh(openDrawer); }, close: closeDrawer, refresh: refresh };

  loadWishlistState(); // cœurs pleins dès le premier rendu si le produit est déjà en wishlist
})();
